import { VisitReportsStoreState } from './visitReportsDataStore/visitReportsData.state';
import { LeadReportsStoreState } from './leadReportsDataStore/leadReportsData.state';
import { OpportunityReportsStoreState } from './opportunityReportsDataStore/opportunityReportsData.state';
// NgRx Store Reducers
import {
    AccountTypesReducer, AnnualRevenuesReducer, CurrenciesReducer, EmployeeCountsReducer, IndustriesReducer, OwnershipsReducer,
    RatingsReducer, TimezonesReducer
} from './accountLeadDataStore/accountLeadData.reducers';
import {
    SalutationsReducer, JobFunctionsReducer, AddressClassesReducer, AddressTypesReducer, CountriesReducer, LanguagesReducer,
    SourcesReducer
} from './sharedDataStore/sharedData.reducers';
import {
    TasksReducer, ReminderTypesReducer, CaseNamesReducer, OpportunityNamesReducer, LeadNamesReducer, AccountNamesReducer,
    TaskCategoriesReducer, TaskModulesReducer
} from './taskDataStore/taskData.reducers';

import { OpportunityReportsReducer } from './opportunityReportsDataStore/opportunityReportsData.reducers';
import { LeadReportsReducer } from './leadReportsDataStore/leadReportsData.reducers';
import { VisitReportsReducer } from './visitReportsDataStore/visitReportsData.reducers';

// NgRx Store Effects
import { AccountLeadDataEffects } from './accountLeadDataStore/accountLeadData.effects';
import { SharedDataEffects } from './sharedDataStore/sharedData.effects';
import { TaskDataEffects } from './taskDataStore/taskData.effects';
import { TerritoryMapStoreState } from './territoryMapDataStore/territoryMapData.state';
import { TerritoryMapReducer } from './territoryMapDataStore/territoryMapData.reducers';
import { DashboardSavedsearchReportsState } from './dashboardSavedsearchReportsDataStore/dashboardSavedsearchReportsData.state';
import { DashboardSavedsearchReportsReducer } from './dashboardSavedsearchReportsDataStore/dashboardSavedsearchReportsData.reducers';

export interface RootReducerState {
    opportunityReports: OpportunityReportsStoreState;
    leadReports: LeadReportsStoreState;
    visitReports: VisitReportsStoreState;
    territoryMap: TerritoryMapStoreState;
    dashboardSavedsearchReports: DashboardSavedsearchReportsState;
}

export const reducers = {
    // Account Reducers
    accountTypes: AccountTypesReducer,
    annualRevenues: AnnualRevenuesReducer,
    currencies: CurrenciesReducer,
    employeeCounts: EmployeeCountsReducer,
    industries: IndustriesReducer,
    ownerships: OwnershipsReducer,
    ratings: RatingsReducer,
    timezones: TimezonesReducer,
    // Shared Reducers
    salutations: SalutationsReducer,
    jobFunctions: JobFunctionsReducer,
    addressClasses: AddressClassesReducer,
    addressTypes: AddressTypesReducer,
    countries: CountriesReducer,
    languages: LanguagesReducer,
    sources: SourcesReducer,
    // Task Reducers
    tasks: TasksReducer,
    taskModules: TaskModulesReducer,
    taskCategories: TaskCategoriesReducer,
    accountNames: AccountNamesReducer,
    leadNames: LeadNamesReducer,
    opportunityNames: OpportunityNamesReducer,
    caseNames: CaseNamesReducer,
    reminderTypes: ReminderTypesReducer,

    //Reports Reducers
    opportunityReports: OpportunityReportsReducer,
    leadReports: LeadReportsReducer,
    visitReports: VisitReportsReducer,
    territoryMap: TerritoryMapReducer,
    dashboardSavedsearchReports: DashboardSavedsearchReportsReducer
};

export const effects = [AccountLeadDataEffects, SharedDataEffects, TaskDataEffects];
